import React from 'react';

// Shimmering placeholder rows (avatar circle + two text bars) for the
// Email feature's list-shaped loading states — used instead of a bare
// "Loading…" line so the surrounding chrome (search box, filters, folder
// sidebar) stays visible immediately rather than the whole panel
// disappearing while data loads.
const ListSkeleton = ({ rows = 6 }) => (
  <div className="skeleton-list">
    {Array.from({ length: rows }).map((_, index) => (
      <div className="skeleton-row" key={index}>
        <span className="skeleton-avatar" />
        <span className="skeleton-lines">
          <span className="skeleton-line skeleton-line-short" />
          <span className="skeleton-line skeleton-line-long" />
        </span>
      </div>
    ))}
  </div>
);

export default ListSkeleton;
